import React, { Component } from 'react';
import "./ProgressCapsules.css";
import { withFirebase } from '../../Firebase';
import { withRouter } from 'react-router-dom';
import Modal from "react-responsive-modal";
import RatingCapsuleModal from "./RatingCapsuleModal";
import trelloBlue from '../../../assets/cards/iconTrelloBleu.svg';
import watchGrey from '../../../assets/cards/icon_attente_big_gris.svg';
import watchBlue from '../../../assets/cards/icon_attente_big_bleu.svg';
import validateGrey from '../../../assets/cards/icon_realise_big_gris.svg';
import validateBlue from '../../../assets/cards/icon_realise_big_bleu.svg';
import DefaultImage from '../../../assets/example-productivity.jpg';
import TrelloCreateBoard from "../CreateTrelloBoard";
import Tooltip from '@material-ui/core/Tooltip';
import { ActivateCapsuleModalForm } from './ActivateCapsuleModalContent';

class ProgressCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      click: true,
      begin: false,
      finish: false,
      pending: false,
      capsule: this.props.capsule,
      numberIdeas: "",
      currentUserInfos: null,
      numberPolls: "",
      ratingOpen: false,
      ratingCapsule: 0,
      calendarOpen: false,
      uid: "",
      newEndDate: null,
      trelloActive: this.props.capsule.status === "pending" ? true : false,
      user: { firstname: "", lastname: "" },
    };
  }

  componentDidMount() {

    this.props.firebase.auth.onAuthStateChanged(async (currentUser) => {

      if (currentUser === null) {
        return
      }
      this.setState({ uid: currentUser.uid })
      this.props.firebase.db
        .collection("capsules")
        .doc(this.props.capsule.id)
        .collection("ideas")
        .get()
        .then(querysnapshot => {
          let ideas = querysnapshot.docs.map(doc => {
            let data = doc.data()
            return {
              id: doc.id,
              ...data
            }
          });
          this.setState({ numberIdeas: ideas.length })
        }).then(() => {
          this.setStatus();
        })

      this.props.firebase.db
        .collection("users")
        .doc(this.props.firebase.auth.currentUser.uid)
        .get()
        .then((doc) => {
          if (doc.exists) {
            const cu = doc.data();
            this.setState({
              currentUserInfos: cu
            });
          }
        })
        .catch((error) => {
          console.error("Error getting document:", error);
        });

      this.props.firebase.db
        .collection("capsules")
        .doc(this.props.capsule.id)
        .collection("polls")
        .get()
        .then(querysnapshot => {
          let polls = querysnapshot.docs.map(doc => {
            let data = doc.data()
            return {
              id: doc.id,
              ...data
            }
          });
          this.setState({ numberPolls: polls.length })
        })

      let querySnapshotCreator = await this.props.firebase.db.collection("users").doc(this.props.capsule.creator).get()
      this.setState({ user: querySnapshotCreator.data() })
    })
  }

  onOpen = (event) => {
    const { click } = this.state;
    if (click === false) {
      this.setState({ click: true })
    } else {
      this.setState({ click: true })
    }
  }

  setStatus = () => {
    const { capsule } = this.state;
    switch (capsule.status) {
      case 'pending':
        this.setState({ pending: true, begin: false, finish: false });
        break;
      case 'begin':
        this.setState({ pending: false, begin: true, finish: false });
        break;
      case 'finish':
        this.setState({ pending: false, begin: false, finish: true });
        break
      default:
        return null;
    }
  }

  changeStatus = (newStatus) => {
    switch (newStatus) {
      case 'pending':
        this.setState({ pending: true, begin: false, finish: false });
        break;
      case 'begin':
        this.setState({ pending: false, begin: true, finish: false });
        break;
      case 'finish':
        this.setState({ pending: false, begin: false, finish: true });
        break
      default:
        return null;
    }
  }

  addRating = (rating, commentaire) => {
    const { capsule, uid, currentUserInfos } = this.state;
    const timestamp = Date.now();
    let ratingList = [];
    let name = currentUserInfos.firstname + ' ' + currentUserInfos.lastname
    let position = currentUserInfos.position ? currentUserInfos.position : '';
    const image = currentUserInfos.image_url_profile ? currentUserInfos.image_url_profile : '';
    let current_rating = { rate: rating, user: uid, commentaire: commentaire, username: name, position: position, image: image }
    ratingList.push(current_rating);
    this.setState({ ratingList: ratingList });
    this.props.firebase.db
      .collection("capsules")
      .doc(capsule.id)
      .set({ status: "finish", ratingList: ratingList, achievementDate: new Date().getTime() }, { merge: true })
      .catch((error) => console.error(error))

    let newHistoric = { date: timestamp, firstname: this.state.currentUserInfos.firstname, lastname: this.state.currentUserInfos.lastname, picture: this.state.currentUserInfos.image_url_profile, status: "realized" }
    this.props.firebase.db.collection('capsules').doc(capsule.id).collection('historic').add(newHistoric)
  }

  clickIcon = (selectedIcon) => {
    const { capsule } = this.state
    switch (selectedIcon) {
      case 'pending':
        this.setState({ pending: true, begin: false, finish: false, trelloActive: true });
        this.props.firebase.db
          .collection("capsules")
          .doc(capsule.id)
          .set({ status: "pending" }, { merge: true })
          .catch((error) => console.error(error));
        break;
      //case begin is handled by CreateTrelloBoard
      case 'finish':
        this.setState({ pending: false, begin: false, finish: true, trelloActive: true });
        this.openRating();
        break
      default:
        return null;
    }
  }

  openRating = () => {
    this.setState({
      ratingOpen: true
    })
  }

  closeRating = () => {
    this.setState({
      ratingOpen: false,
    })
  }

  openCalendar = (assignmentID) => {
    this.setState({
      calendarOpen: true,
    })
  }

  closeCalendar = () => {
    this.setState({
      calendarOpen: false
    })
  }

  setEndDate = (date) => {
    this.setState({
      newEndDate: date
    })
  }

  test = () => {
    this.setState({ idea: true });
    this.setState({
      ideaOpen: false,
    })
  }

  statesCard = () => {
    const { click, begin, finish, pending, capsule, trelloActive, user } = this.state
    if (click === true) {
      return (
        <div className="rectangle-states mt-4 mb-5 p-3">
          <h1 className="title-cps-states mb-4">Mettre à jour le statut de la capsule</h1>
          <div className="d-flex text-center justify-content-center">
            <div hidden={!this.props.page}>
              <Tooltip title="Passer en attente" aria-label="pending">
                <img className="cursor-pointer" alt="watchGrey" hidden={pending === true} onClick={() => this.clickIcon("pending")} src={watchGrey} />
              </Tooltip>
              <Tooltip title="Passer en attente" aria-label="pending">
                <img className="cursor-pointer" alt="watchBlue" hidden={pending === false} onClick={() => this.clickIcon("pending")} src={watchBlue} />
              </Tooltip>
              <h2 hidden={pending === true} className="text-cps-states">En attente d'activation</h2>
              <h2 hidden={pending === false} className="text-cps-states-color">En attente d'activation</h2>
            </div>
            <div>
              <TrelloCreateBoard
                capsuleName={capsule.title}
                capsule={capsule}
                capsuleId={capsule.id}
                assigneeId={capsule.assigneeId}
                currentUserId={this.props.firebase.auth.currentUser.uid}
                user={user}
                forProgressCards={true}
                activeForProgressCards={trelloActive}
                changeLocalStatus={this.changeStatus}
              />
              <h2 hidden={begin === true} className="text-cps-states">Activée</h2>
              <h2 hidden={begin === false} className="text-cps-states-color">Activée</h2>
            </div>
            <div hidden={this.props.page === "accepted"}>
              <Tooltip title="Réaliser la capsule" aria-label="trello">
                <img className="cursor-pointer" alt="validateGrey" hidden={finish === true} onClick={() => this.clickIcon("finish")} src={validateGrey} />
              </Tooltip>
              <img className="cursor-pointer" alt="validateBlue" hidden={finish === false} onClick={() => this.clickIcon("finish")} src={validateBlue} />
              <h2 hidden={finish === true} className="text-cps-states">Réalisée</h2>
              <h2 hidden={finish === false} className="text-cps-states-color">Réalisée</h2>
            </div>
          </div>
        </div>
      )
    } else {
      return (<></>)
    }
  }

  openCapsule = () => {
    const { capsule } = this.state
    this.props.history.push(`/capsule/${capsule.id}`);
  }

  render() {
    const { capsule, begin, finish, pending, numberIdeas, numberPolls, calendarOpen, newEndDate, user } = this.state;
    let currentdate = new Date().getTime()
    let startDate = capsule.startedDate;
    let endDate = capsule.endDate;
    let firstvalue = currentdate - startDate;
    let secondevalue = endDate - startDate;

    // let user_history = {firstname: user.firstname, lastname : user.lastname, picture: user.image_url_profile}


    let value = ((firstvalue * 100) / (secondevalue))

    if (value > 0) {
      value = Math.round(value)
    }
    else if (endDate === undefined) {
      value = 0
    }
    else {
      value = 100;
    }

    let currentNewEndDate = newEndDate ? new Intl.DateTimeFormat('fr-FR', { year: 'numeric', month: '2-digit', day: '2-digit' }).format(Number(newEndDate)) : ''
    let progressEndDate = endDate ? new Intl.DateTimeFormat('fr-FR', { year: 'numeric', month: '2-digit', day: '2-digit' }).format(Number(capsule.endDate)) : ''
    return (
      <div>
        <div className="inactive-card card">
          <img onClick={this.openCapsule} className="card-img-top img-cropper" src={capsule.image_url_capsule || DefaultImage} alt="Card" onError={this.props.firebase.capsuleImgError} />
          <div className="reactive-card-header">
            <div className="reactive-card-title">{capsule.title}</div>
          </div>

          <img className="basic-card-bottom-background" src={require('../../../assets/cards/card_white_no_shape.svg')} alt="Bottom" />
          <div onClick={this.onOpen} className="reactive-card-body progress-body">
            <p className="activated-text-blue"> Créée par {user.firstname} {user.lastname}</p>
            <p className="reactive-card-other-text">{numberPolls} {(1 === numberPolls) ? 'sondage' : 'sondages'}</p>
            <p className="reactive-card-other-text">{numberIdeas} {(numberIdeas === 1) ? 'idée' : 'idées'}</p>

            <div className="reactive-card-footer">
              <div className="size-tag-container">
                {capsule.tags.slice(0, 2).map((tag, index) => <div key={index} className="reactive-card-tag">#{tag}</div>)}
              </div>
              <div className="reactive-card-like-container position-like">
                <div className="reactive-card-like-text mr-2">{capsule.nbLikes}</div>
                <img src={require('../../../assets/cards/icon_card_like.svg')} alt="Like" />
              </div>
              <div className="reactive-card-like-container position-logo">
                <img alt="defis" hidden={!(pending === true)} className="reactive-card-like-icon" src={require('../../../assets/cards/icon_defis_time.svg')} />
                <img alt="fuse" hidden={!(begin === true)} className="reactive-card-like-icon" src={trelloBlue} />
                <img alt="realise" hidden={(!finish === true)} className="reactive-card-like-icon" src={require('../../../assets/cards/icon_defis_realises.svg')} />
              </div>
            </div>
            <div className="mt-2 progress progress-bar-size">
              <div hidden={!(value >= 80 || value < 0)} className="progress-bar bg-danger" role="progressbar" style={{ width: value.toString() + "%" }} aria-valuenow={value.toString()} aria-valuemin="0" aria-valuemax="100"></div>
              <div hidden={!(value >= 50 && value < 80)} className="progress-bar bg-warning" role="progressbar" style={{ width: value.toString() + "%" }} aria-valuenow={value.toString()} aria-valuemin="0" aria-valuemax="100"></div>
              <div hidden={!(value < 50)} className="progress-bar" role="progressbar" style={{ width: value.toString() + "%" }} aria-valuenow={value.toString()} aria-valuemin="0" aria-valuemax="100"></div>
            </div>
            {newEndDate ? <span className="date-progress-card text-right">{currentNewEndDate}</span> : <span className="date-progress-card text-right">{progressEndDate}</span>}
          </div>
        </div>
        {this.statesCard()}
        <Modal
          open={this.state.ratingOpen}
          onClose={this.closeRating}
          center
          showCloseIcon={true}
          styles={(window.innerWidth > 768) ? styles_desktop : styles_mobile}
        >
          <RatingCapsuleModal
            onClose={this.closeRating}
            addRating={this.addRating}
            onTest={this.test} />
        </Modal>
        <Modal
          open={calendarOpen}
          onClose={this.closeCalendar}
          onEndDate={this.setEndDate}
          center
          showCloseIcon={true}
          styles={(window.innerWidth > 768) ? styles_calendar : styles_mobile}
        >
          <ActivateCapsuleModalForm
            onClose={this.closeCalendar}
            onEndDate={this.setEndDate}
            capsuleID={capsule.id} />
        </Modal>
      </div>
    )
  }
}

const styles_calendar = {
  overlay: {
    display: "block",
    position: "fixed",
    left: 0,
    top: 0,
    zIndex: 9999,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0.79)",
    overflow: "auto",
  },
  modal: {
    boxShadow: 'none',
    borderRadius: '4px',
    minHeight: "650px",
    maxWidth: "395px",
    top: "10%",
    padding: "0px",
  }
};

const styles_desktop = {
  overlay: {
    display: "block",
    position: "fixed",
    left: 0,
    top: 0,
    zIndex: 9999,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0.79)",
    overflow: "auto",
  },
  modal: {
    boxShadow: 'none',
    borderRadius: '4px',
    minHeight: "355px",
    maxWidth: "376px",
    top: "10%",
    padding: "0px",
  }
};

const styles_mobile = {
  overlay: {
    display: "block",
    position: "fixed",
    left: 0,
    top: 0,
    zIndex: 9999,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0.79)",
    overflow: "auto",
    padding: "0px",
  },
  modal: {
    boxShadow: 'none',
    minHeight: "100%",
    width: "100%",
    padding: "0px",
  }
};

const ProgressCardBase = withRouter(withFirebase(ProgressCard));

export default ProgressCardBase;